module.exports = __webpack_public_path__ + "static/media/adicionar_cliente.21d09700.svg";